import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { docVerifyCredential } from '../ReduxState';
import { checkinModule } from '../Utility/CommonFun';
import { useHistory, useLocation } from 'react-router-dom';
import { fncLogoutApi } from '../Utility/ApiCall.js';
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, Form } from "react-bootstrap";
import { toast } from 'react-toastify';
export default function DocumentVerificationModal(props) {
const Sessiontimeout =useRef(null);
  const notify = (e) =>    
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
  );
    const dispatch = useDispatch()
    let history = useHistory();
    const location = useLocation();
    const [modalShow, setmodalShow] = useState(true);

    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const { passenger } = SearchedFlightDetails;
    const passengerArr = SearchedFlightDetails && SearchedFlightDetails.passenger ? passenger.filter(p => p.IsSelected): [];
    let selectedPassengers = passengerArr;
    // // console.log('passengerArr.some(p => p.infant)', passengerArr.some(p => p.infant));
    if (passengerArr.some(p => p.infant)) {
        const infants = passengerArr.filter(p => p.infant);
        infants.forEach(inf => {
            const infant = inf.infant;
            infant.associatedWithPassenger = inf.passengerKey;
            infant.IsSelected = true;
            selectedPassengers.push(infant);
        });
    }

    const newarr = [];

    const infantsInArray = selectedPassengers.filter(p => p.associatedWithPassenger);
    // console.log('infantsInArray', infantsInArray);
    selectedPassengers.forEach((item, i) => {
        if (item.passengerKey && item.infant) {
            const inf = infantsInArray.find(inf => inf.associatedWithPassenger === item.passengerKey);
            if (inf) {
            newarr.push(inf)
            }
        }
        newarr.push(selectedPassengers[i]);
    });
    selectedPassengers = newarr.slice(0, newarr.length - infantsInArray.length);
    // console.log('a', selectedPassengers);
    if (infantsInArray.length) {
        let temp = 0;
        if (selectedPassengers.length % 2 === 1) {
            
            for (let i = 0; i < selectedPassengers.length - 1; i = i + 2) {
            temp = selectedPassengers[i];
            selectedPassengers[i] = selectedPassengers[i + 1];
            selectedPassengers[i + 1] = temp;
            }
        } else if (selectedPassengers.length % 2 === 0) {
            for (let i = 0; i < selectedPassengers.length; i = i + 2) {
            temp = selectedPassengers[i];
            selectedPassengers[i] = selectedPassengers[i + 1];
            selectedPassengers[i + 1] = temp;
            }
        }
    }

    const getVerificationIcon = (pax, td) => {
      // console.log('getVerificationIcono----', pax,td);
      // const selectedSegmentKeyArr = SearchedSelectedPassengerData.SelectedSegmentKey;
      if (td) {
          const { birthCountry, dateOfBirth, documentTypeCode, expirationDate, issuedByCode, issuedDate, name, nationality, number } = td;
          if (birthCountry !== ''
          && dateOfBirth !== ''
          && documentTypeCode !== ''
          && expirationDate !== ''
          && issuedByCode !== ''
          && issuedDate !== ''
          && nationality !== ''
          && number !== ''
          && name && name.first !== '' && name.last !== '' && name.title !== ''
          ) {
              return true
          } else {
              return false;
          }
      } else {
          return false;
      }
    }

    const checkIfDocsAreVerified = () => {
      /** check for all the passengers if they have document with all the properties */
      let returnFlag = false;
      for(let i=0; i < selectedPassengers.length; i++) {
        if (selectedPassengers[i].traveldocuments && selectedPassengers[i].traveldocuments.length) {
            for(let j=0; j < selectedPassengers[i].traveldocuments.length; j++) {
                if (!getVerificationIcon(selectedPassengers[i], selectedPassengers[i].traveldocuments[j])) {
                    // setisNextDisabled(true);
                    returnFlag = false;
                    break;
                } else {
                  returnFlag = true;
                  // setisNextDisabled(false);
                }
            }
        } else {
          returnFlag = false;
          // setisNextDisabled(true);
        }
      }
      return returnFlag;
      //isNextDisabled
    }

    function fncDocumentsVerifed() {
        // console.log('Documents are verified', location.pathname);
        if (checkIfDocsAreVerified()) {
          dispatch(docVerifyCredential(
            {
              type: '',
              documentsVerified: true
            }
          ))
        } else {
          notify('Document(s) are not either filled or verified for passenger(s).');
          if (location.pathname !== '/SecurityTravelDoc') {
            history.push('/SecurityTravelDoc');
          }
          dispatch(docVerifyCredential(
            {
              type: '',
              documentsVerified: false
            }
          ))
        }
        setmodalShow(false);
    }

    function fncDocumentsNotVerifed() {
      // console.log('Documents are not verified, go to security');
      if (location.pathname !== '/SecurityTravelDoc') {
        history.push('/SecurityTravelDoc');
      }
      setmodalShow(false);
    }
 useEffect(() => {
          if (modalShow) {
            if(Sessiontimeout.current){
              Sessiontimeout.current.focus();

            }
          }
  }, [modalShow]);
  const   handlefocus=() => {
    const amountInput = document.getElementById("sessinoutNo");
    if (amountInput) {
      amountInput.focus();
    }
  }
    return (props.trigger) ? (
        <Modal
        show={modalShow}
        onHide={fncDocumentsNotVerifed}
        >
          <Modal.Header 
          // closeButton
          >
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are all passenger(s) documents verified ?
            <strong></strong>
          </Modal.Body>
          <Modal.Footer>
          <button className="focusClass btn btn-red OrangeShadow SerachBtn" onClick={fncDocumentsNotVerifed} id="sessinoutNo" ref={Sessiontimeout}>
            No
          </button>
          <button  onBlur={handlefocus} className="focusClass btn btn-red OrangeShadow SerachBtn" onClick={fncDocumentsVerifed}>Yes</button>
        </Modal.Footer>
        </Modal>
    ) : "";

}